@if (busyMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyMessageManager.message"></ws-busy-indicator>
}

<ws-modal-wrapper headerLabel="Upload Template"
                  (save)="upload()"
                  (cancel)="cancel()"
                  [disableSave]="!file">
    <form name="importUploadForm">
        <div class="mb-4">
            <label>Select a file (must be .pdf file):</label>
            <ws-file-picker (picked)="filePicked($event)"></ws-file-picker>
        </div>
    </form>
</ws-modal-wrapper>
